export default  {
    template: require('../views/spinner.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/components/spinner.component.js